import kr from '../kr/kr';

export default class SelectColor extends kr.Module
{
    init() {
        this._selects = document.querySelectorAll('select');

        this.bind();
    }

    bind() {
        for (let i in this._selects) {
            if (!this._selects.hasOwnProperty(i)) {
                continue;
            }

            const select = this._selects[i];
            select.addEventListener('change', function(){
                this.style.color='#000';
            });
        }
    }
}